import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Activity, Bell, Map as MapIcon, Menu } from "lucide-react";

const items = [
  { to: "/dashboard", label: "Dashboard", icon: Home },
  { to: "/live-monitor", label: "Live", icon: Activity },
  { to: "/alerts", label: "Alerts", icon: Bell },
  { to: "/floors", label: "Floors", icon: MapIcon },
  { to: "/menu", label: "More", icon: Menu },
];

export default function MobileTabs() {
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 glass-strong border-t border-gray-200 px-2 py-1 flex justify-around" data-testid="mobile-tabs">
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <NavLink key={it.to} to={it.to} className={({ isActive }) =>
            `flex flex-col items-center gap-0.5 py-2 px-3 rounded-lg ${isActive ? "f360-gradient-text" : "text-slate-400"}`
          }>
            <Icon className="w-5 h-5" />
            <span className="text-[10px]">{it.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
